import { SectionEventTrack } from '../domain/dtos'

export const makeSectionEventData = (data: SectionEventTrack) => ({
  userId: data.userId,
  productId: data.productId,
  sectionId: data.sectionId,
})
